import * as React from 'react';
import { FieldProps } from '../types';
import { useFormContext } from './contexts/form';

const Field: React.FC<FieldProps> = ({ field, setFieldRef }) => {
	const { handleChange, errors, loading } = useFormContext();

	const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;

		// Allow only numbers and a single decimal point
		if (/^\d*\.?\d*$/.test(value)) {
			handleChange(field.id, value);
		}
	};

	return (
		<fieldset className="app-calculator__fieldset">
			<label className="app-calculator__label" htmlFor={field.id}>
				{field.label}{' '}
				{field.tooltip && (
					<span className="app-calculator__tooltip-icon">
						<span className="app-calculator__tooltip-value">{field.tooltip}</span>
					</span>
				)}
			</label>
			<div
				className={`app-calculator__input-container ${
					errors[field.id] ? 'app-calculator__input-container--error' : ''
				}`}
			>
				{field.prefix && <div className="app-calculator__input-prefix">{field.prefix}</div>}
				<input
					className={`app-calculator__input ${
						errors[field.id] ? 'app-calculator__input--error' : ''
					}`}
					type="text"
					id={field.id}
					name={field.id}
					value={field.value || ''}
					onChange={handleInput}
					disabled={loading}
					ref={setFieldRef as React.Ref<HTMLInputElement>}
				/>
				{field.suffix && <div className="app-calculator__input-suffix">{field.suffix}</div>}
			</div>
		</fieldset>
	);
};

export default Field;
